import { useMutation } from "react-query";

import type { OtPurpose } from "@jti/fe-common";
import type { IUser } from "@jti/rest-api-types";

import { CasPurposesApi } from "../../../services";
import { buildContestPayload, extractConsents } from "../../../utils";
import { useSubmitContest } from "../useSubmitContest";

type HandleLoyaltySubmitParams = {
  formValues: Record<string, any>;
  user: IUser;
  consentFields: OtPurpose[];
};

export const useLoyaltyContestSubmit = () => {
  const handleStartContest = useSubmitContest();

  return useMutation({
    mutationFn: async ({ formValues, user, consentFields }: HandleLoyaltySubmitParams) => {
      if (!user?.uuid || !user?.ciam_token) {
        throw new Error("Missing user credentials");
      }

      const casPurposesApi = CasPurposesApi.init();

      if (consentFields.length > 0) {
        const consentValues = extractConsents(formValues, consentFields);
        await casPurposesApi.updateUserConsentsEvo(consentValues);
      }

      const contestPayload = buildContestPayload(formValues);
      await handleStartContest.mutateAsync({
        uuid: user.uuid,
        ciam_token: user.ciam_token,
        formData: contestPayload,
      });
    },
    retry: false,
  });
};
